module.exports = __webpack_public_path__ + "static/recipe-collect-1-ab66aa1440c0819e606b39324595d3cb.png";